import React from 'react';

const ModalCloseButton = props => (
  <button className="c-modal__close" {...props} />
);

export default ModalCloseButton;



// WEBPACK FOOTER //
// ./src/app/components/ModalCloseButton.jsx